// @flow

import './PhoneInput.css'

import styled, { css } from 'styled-components'
import { media } from 'src/theme/style-utils'

export { default as Address } from './Address'
export { default as Details } from './Details'
export { default as PaymentDetails } from './Payment'

export const StyledFormPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
 
  background-color: #ffffff;
  ${media.tablet`
    overflow-y: auto;
    margin: 0 auto;
  `}
  ${media.desktop`
    overflow-y: unset;
  `}
  ${media.giant`
 
  `}
`

export const StyledFormInfo = styled.div`
  width: 100%;
  z-index: 100;
  box-sizing: border-box;

  ${props =>
    !props.modalLayout
      ? css`
          box-shadow: 0px 0px 20px -4px rgb(200, 200, 200);
        `
      : css`
          margin: 25px 0 0 0;
        `}
  background-color: #ffffff;
  ${media.phone`
   ${props =>
     !props.modalLayout &&
     css`
       width: 95%;
       margin-left: 10px;
       margin-bottom: 20px;
     `}
 
  `};

  ${media.desktop`
    margin-bottom: 20px;
    width: 38%;
    ${props =>
      props.isSticky &&
      css`
        top: 20px;
        width: 390px
        position: sticky;
        align-self: flex-start;
       `};
    
  `};
`

export const StyledArticle = styled.article`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  max-width: 1200px;

  ${media.tabletLarge`
    flex-direction: column;
    flex-direction: column-reverse;
  `};

  ${media.desktop`
    flex-direction: row;
    justify-content: space-between;
    width: 1024px;
  `};
`

export const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  ${media.desktop`
    width: 100%;
    ${props =>
      props.isWide &&
      css`
        width: 100%;
      `};
  `};

  ${media.desktop`
    width: 60%;
    ${props =>
      props.isWide &&
      css`
        width: 100%;
      `};
  `};
`

export const FieldCollection = styled.div`
  width: 100%;
  background-color: #ffffff;
  ${props => props.isYellow && 'background-color: #ffeb99;'};
  ${props =>
    props.hasShadow &&
    `-webkit-box-shadow: 0px 0px 20px -4px rgb(200,200,200);
    -moz-box-shadow: 0px 0px 20px -4px rgb(200,200,200);
    box-shadow: 0px 0px 20px -4px rgb(200,200,200);
  `};
  box-sizing: border-box;
  padding: 30px 40px 50px 40px;
  margin-bottom: 20px;
  position: relative;

  ${media.phone`
    width: 95%;
    margin: 0 10px 20px 10px;
    padding: 30px 20px 50px 20px;
  `};

  ${media.tabletLarge`
    width: 95%;
    margin: 0 10px 20px 10px;
    padding: 30px 40px 50px 40px;
  `};

  ${props =>
    props.noPadding
      ? `padding-left: 0!important;
  padding-right: 0!important;
  `
      : ''};
`

export const FormField = styled.div`
  position: relative;
  width: 100%;
  ${props => (props.hasError ? 'margin-bottom: 45px!important' : '')}
  margin: 23px auto ${props => (props.isInitPage ? '20px' : '0')};
  box-sizing: border-box;
  ${props => (props.isFlex === true ? 'display: flex;' : '')}
  &:focus-within {
    & label {
      color: #4a5665;
    }
  }
  
  ${props => (props.noTopMargin === true ? 'margin-top: 0!important;' : '')}
  ${media.tablet`
    width: 100%;
    margin-top: 30px;
    ${props =>
      props.moreMargin &&
      css`
        margin-top: 50px;
      `}
    `}
  ${props =>
    props.noborder &&
    css`
      border: none;

      &:focus-within {
        border: none;
      }
    `}
  ${props =>
    props.moreMargin &&
    css`
      margin-top: 50px;
    `}
  ${props =>
    props.noMargin &&
    css`
      margin-left: 0;
    `}
`

export const Check = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid ${props => props.theme.secondary}
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    display: none;

    left: 5px;
    top: 3px;
    width: 3px;
    height: 6px;
    border: 1px solid ${props => props.theme.darkText};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`

export const Checkbox = styled.label`
  margin-top: 26px;
  margin-bottom: 30px;
  height: 20px;
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 30px;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 16px;
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  color: ${props => props.theme.darkText}
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  & input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  & input:checked ~ ${Check}:after {
    display: block;
  }

  & input:checked ~ ${Check} {
    border: 2px solid ${props => props.theme.darkText}
  }

  &:hover input ~ ${Check} {
    ${'' /* background-color: #ccc; */}
  }
`

export const Checkmark = styled.span`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 118px;
  height: 50px;
  color: ${props => props.theme.primaryText};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: solid 1px ${props => props.theme.secondary};
  background-color: #fff;
  margin: 0;
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    display: none;

    left: 67px;
    top: 10px;
    width: 7px;
    height: 17px;
    border: 1px solid ${props => props.theme.primary};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`

export const StyledCheckbox = styled.label`
  display: block;
  position: relative;
  padding-left: 150px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.theme.primaryText}
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  @keyframes sheen {
    0% {
      ${'' /* transform: rotateZ(60deg) translate(1em, -9em); */}
      border-color: #fff;
    }
    100% {
      ${'' /* transform: rotateZ(60deg) translate(0, 0); */}
      border-color: ${props => props.theme.primary};
    }
  }


  & input[type="radio"] {
    /* Hide original inputs */
    visibility: hidden;
    position: absolute;
  }

  & input:checked ~ ${Checkmark} {
    color: ${props => props.theme.darkText};
    font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
    border: solid 1px ${props => props.theme.darkText};
    box-shadow: none;
    text-align: left;
    padding-right: 30px;
    &:after {
      display: block;
      animation: sheen 1s forwards;
    }
  }

  &:hover input ~ ${Checkmark} {
    color: ${props => props.theme.primary};
  }
`

export const Radiomark = styled.span`
  position: absolute;
  left: 5px;
  width: 20px;
  height: 20px;
  border-radius: 12px;
  border: solid 1px ${props => (props.hasError ? '#ff4a4a' : '#082622')};
  box-sizing: border-box;
  background-color: #ffffff;
  transition: background 0.3s linear;
  margin: 0;

  @keyframes radio-button {
    0% {
      transform: translateY(-50%) scale(0);
      box-shadow: 0 0 0px rgba(0, 0, 0, 0.2);
    }
    80% {
      transform: translateY(-50%) scale(1.2);
    }
    100% {
      transform: translateY(-50%) scale(1);
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    }
  }

  &:after {
    width: 10px;
    height: 10px;
    position: absolute;
    left: 4px;
    top: 9px;
    border-radius: 50%;
    background-color: #082622;
    content: '';
    transform-origin: center;
    display: none;
  }
`

export const StyledRadio = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.theme.darkText}
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  & input[type="radio"] {
    /* Hide original inputs */
    visibility: hidden;
    position: absolute;
  }

  & input:checked ~ ${Radiomark} {
    background-color: #ffffff;
    box-shadow: none;
  }

  & input:checked ~ ${Radiomark}:after {
    display: block;
    animation: radio-button 0.3s normal forwards;
  }

  &:hover input ~ ${Radiomark} {
    ${'' /* background-color: ${props => props.theme.primary}; */}
  }
`

export const DisabledSuffix = styled.div`
  position: relative;
  top: ${props => (props.pushSuffix ? '15px' : '15px')};
  left: -5px;
  white-space: nowrap;
  color: #d2d9e2;
`

export const StyledField = styled.div`
  display: flex;
  border: solid 1px ${props => props.theme.secondary};
  margin: 5px 0 0 0;
  min-height: 50px;
  box-sizing: border-box;

  & select, input[type='date'] {
    /* Hide original inputs */
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: ${props => props.theme.white};
  }

  &:focus-within {
    outline: none;
    border: solid 1px ${props => props.theme.dark};
  }

  ${props =>
    props.noBorder &&
    css`
      border: solid 1px ${props => props.theme.transparent};
      &:focus-within {
        border: solid 1px ${props => props.theme.transparent};
      }
    `}
  ${props =>
    props.hasError &&
    css`
      border: solid 1px ${props => props.theme.danger};
      margin-bottom: ${props => (props.isInitPage ? '0' : '35px;')};
      ${props =>
        props.noBorder &&
        css`
          border: solid 1px ${props => props.theme.transparent};
          &:focus-within {
            border: solid 1px ${props => props.theme.transparent};
          }
        `};
    `}
  ${props =>
    props.column &&
    css`
      flex-direction: column;
    `}
  ${props =>
    props.fullWidth &&
    css`
      width: 100%;
      height: 50px;
      box-sizing: border-box;
      margin: 0;
    `}
`

export const StyledInput = styled.input`
  width: ${props => (props.disabled ? '30px' : '82%')};
  height: 50px;
  color: ${props => (props.disabled ? '#d2d9e2' : props.theme.darkText)};
  border-radius: 3px;
  background-color: transparent;
  font-size: 16px;
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  border: none;
  outline: none;
  margin-left: 10px;
  padding: 0 10px;
  &::placeholder {
    color: ${props => props.theme.lightText};
  }
`

export const StyledSelect = styled.select`
  font-size: 16px;
  width: 100%;
`

export const Label = styled.label`
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  letter-spacing: 0.33px;
  color: ${props => props.theme.lightText};
  padding-bottom: 5px;

  &:focus {
    outline: none;
  }
`
export const SecondLabel = styled.span`
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  font-size: 13px;
  letter-spacing: 0.33px;
  color: ${props => props.theme.lightText};
  padding-bottom: 5px;

  &:focus {
    outline: none;
  }
`

export const Error = styled.span`
  position: absolute;
  font-family: 'RelativeFaux', 'Helvetica', 'Arial', sans-serif;
  bottom: ${props => (props.noLeft ? '4px' : '-31px')};
  left: 0;
  white-space: nowrap;
  font-size: 10px;
  color: ${props => props.theme.danger};
  border: thin solid #ff4f24;
  background-color: #ffebeb;
  box-sizing: border-box;
  width: 100%;
  padding: 5px;
  border-radius: 3px;
  ${props =>
    !props.hideArrow &&
    `
    &:before {
        content: '';
        display: block;
        position: absolute;
        left: ${props.arrowLeft ? `${props.arrowLeft}px` : '10px'};
        bottom: 100%;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-bottom-color: #ff323f;
     }
    &:after {
      content: '';
      display: block;
      position: absolute;
      left: ${props.arrowLeft ? `${parseInt(props.arrowLeft, 10) + 1}px` : '11px'};
      bottom: 100%;
      width: 0;
      height: 0;
      border: 9px solid transparent;
      border-bottom-color: #ffeaea;
    }
  `};
`

export const ErrorNormal = styled.span`
  position: absolute;
  font-family: 'RelativeFaux', 'Helvetica', 'Arial', sans-serif;
  bottom: -21px;
  left: 0;
  white-space: nowrap;
  font-size: 12px;
  color: ${props => props.theme.danger};
  box-sizing: border-box;
  width: 100%;
`

export const Info = styled.div`
  color: ${props => props.theme.primaryText};
  background-color: ${props => props.theme.info};
  border-top: solid 1px ${props => props.theme.secondary};
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  border-radius: 0 0 2px 2px;
  margin-top: 3px;
  padding: 10px;
  font-size: 14px;
  ${media.desktop`
    width: 100%;
    height: auto;
    `};
`



// WEBPACK FOOTER //
// ./src/components/Form/index.js